import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { filter, map, Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { isPlatformBrowser } from '@angular/common';


export const userPermissionGuard = (requiredPermission: 'canCreateEditSales' | 'canViewSales' |'canDeleteSales'): CanActivateFn => {
    // 2. The factory function RETURNS the actual CanActivateFn
    return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean => {

        const platformId = inject(PLATFORM_ID);
        const router = inject(Router);

        const user = localStorage?.getItem('currentUser');
        if (isPlatformBrowser(platformId) && user) {
            if (user && JSON.parse(user) && JSON.parse(user).role === 'admin') {
                return true;
            }
            if (user && JSON.parse(user) && JSON.parse(user)?.permissions?.[requiredPermission]) {
                return true;
            }

        }
        router.navigateByUrl('/');
        return false;
    };
};
